<template>
  <div class="page-container">
    <div v-if="!this.loading" class="verify-email-container">
      <div v-if="this.correctVerification" class="header"><img src="../assets/checkmark.svg" alt="" /></div>
      <div v-else class="wrong-header">X</div>

      <div class="sent-text">{{ message }}</div>

      <a class="bottom-text" @click="$router.push('login')">Back to Login</a>
    </div>

    <div v-else class="verify-email-container">
      <div class="waiting-header"><img src="../assets/checkmark.svg" alt="" /></div>
      <div class="loading-container">
        <v-progress-circular :size="50" color="#434343" indeterminate></v-progress-circular>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    loading: true,
    correctVerification: false,
    message: "No token ID",
  }),
  methods: {
    async submitToken(token) {
      axios
        .post(this.$store.state.serverURL + "/users/verifyEmail", { token: token }, { withCredentials: true })
        .then((res) => {
          this.loading = false;
          this.correctVerification = true;
          this.message = res.data
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.correctVerification = false;
          this.message = err.request.responseText;
        });
    },
  },
  mounted() {
    var token = this.$route.query.token;
    if (token == null) {
      this.loading = false;
      this.correctVerification = false;
      return false;
    }

    this.submitToken(token);
  },
};
</script>

<style scoped>
.verify-email-container {
  width: 380px;
  height: 250px;
  position: absolute;
  top: calc(50% - 225px);
  left: calc(50% - 190px);
  background-color: white;
  box-shadow: 0px 2px 4px rgba(0, 41, 199, 0.2);
  border-radius: 4px;
  display: flex;
  justify-content: center;
}

.bottom-link-text {
  position: absolute;

  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 20px;
  /* or 143% */

  text-align: center;
  width: 210px;

  top: 190px;

  color: #808080;
}

.sent-text {
  position: absolute;
  top: 140px;
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  /* identical to box height, or 120% */

  text-align: center;

  color: #4a4a4a;
}

.header {
  width: 100%;
  height: 100px;
  background-color: #6ebc2c;

  color: white;

  position: absolute;
  padding-top: 35px;
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  /* identical to box height, or 133% */

  text-align: center;
}
.wrong-header {
  width: 100%;
  height: 100px;
  background-color: #ed5564;

  color: white;

  position: absolute;
  padding-top: 35px;
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 60px;
  line-height: 32px;
  /* identical to box height, or 133% */

  text-align: center;
}
.waiting-header {
  width: 100%;
  height: 100px;
  background-color: #434343;

  color: white;

  position: absolute;
  padding-top: 35px;
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  /* identical to box height, or 133% */

  text-align: center;
}

.loading-container {
  position: absolute;
  top: 150px;
}
.bottom-text {
  position: absolute;
  top: 190px;

  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 16px;
  /* identical to box height, or 123% */

  text-align: center;

  /* Indigo / 400 */

  color: #5774e7;
}
</style>
